import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { PowerSupplyService } from '@psnb/services';
import { DatesharedService } from 'desktop/power-supply/power-supply-edit/dateshared.service';
import { ValidationErrorDialog } from 'desktop/power-supply/Upload/power-supply-bulk-upload/validation-error-dialog';

@Component({
  selector: 'app-psnb-certhistory',
  templateUrl: './psnb-certhistory.component.html',
  styleUrls: ['./psnb-certhistory.component.scss']
})
export class PsnbCerthistoryComponent implements OnInit {

  private gridApi;
  private gridColumnApi;
  public context;
  public frameworkComponents;
  public defaultColDef;
  public editType;
  rowData:any;
  @Input()powerSupplyIdval: number;
  @Input()certId: number;
  showProgressBar_load: boolean = false;
  showLoading: boolean = false;
  certDataId:any;
  certData:any;
  expbtn:any;
  private validationErrorDialog: MatDialogRef<ValidationErrorDialog>;

  constructor( private sharedService : DatesharedService,
    private powerSupplyService: PowerSupplyService,
    private dialog: MatDialog,
    private ref: ChangeDetectorRef,) {

  }

  ngOnInit(): void {
     //Function for getting all the certification data
     this.showLoading = true;
     let certDataId = null;
     this.powerSupplyService.getPSCertificationAll(this.powerSupplyIdval,certDataId).subscribe(certAll => {
      //let rowDataValue = this.processData(certAll);
      this.rowData = certAll;
      this.showLoading = false;
      this.ref.detectChanges();
      if(this.rowData == ''){
        //this.openDialog("No Data Found");
        this.expbtn = true;
      }
     });
  }

  // openDialog(message: string) {
  //   this.validationErrorDialog = this.dialog.open(ValidationErrorDialog, {
  //     data: {},
  //     disableClose: true
  //   })
  // }
  // export(){
  //   this.sharedService.editpssetDataExportCall();
  // }

  // processData(rowData) {
  //   rowData.forEach(element => {
  //     element.powerSupplyId = (element.powerSupplyCertifications.powerSupplyId) ? element.powerSupplyCertifications.powerSupplyId : null;
  //     element.psCertificationId = (element.powerSupplyCertifications.psCertificationId) ? element.powerSupplyCertifications.psCertificationId : null;
  //     element.certificationDate = (element.powerSupplyCertifications.certificationDate) ? new Date(element.powerSupplyCertifications.certificationDate).toLocaleString()  : null;
  //     element.technicianName = (element.powerSupplyCertifications.technicianName) ? element.powerSupplyCertifications.technicianName : null;
  //     element.macAddress = (element.powerSupplyCertifications.macAddress) ? element.powerSupplyCertifications.macAddress : null;
  //     element.typeOfVisit = (element.powerSupplyCertifications.typeOfVisit) ? element.powerSupplyCertifications.typeOfVisit : null;
  //     element.inspectionDate = (element.powerSupplyCertifications.inspectionDate) ? new Date(element.powerSupplyCertifications.inspectionDate).toLocaleString() : null;
  //     element.logName = (element.powerSupplyCertifications.logName) ? element.powerSupplyCertifications.logName : null;
  //     element.logDate = (element.powerSupplyCertifications.logDate) ? new Date(element.powerSupplyCertifications.logDate).toLocaleString()  : null;
  //   });
  //   return rowData;
  // }

  // columnDefs = [
  //   {
  //     headerName: 'Action', field: 'triageId', cellClass: 'action', width: 120, minWidth: 120, filter: false, sortable: false, cellRenderer: (props) => {
  //       const style = "background-color: #087ed1; color: white; height:25px; border-radius: 4px; border: 0px;";
  //       var eDiv = document.createElement('div');
  //       eDiv.innerHTML = `<button mat-raised-button style="${style}" class="button review-changes"><b>View Certification</b></button>&nbsp;&nbsp;`;
  //       var eButton = eDiv.querySelectorAll('.review-changes')[0];
  //       eButton.addEventListener('click', () => {
  //         // setTimeout(() => {
  //         //   this.sharedService.editpssetData('true');
  //         // });
  //         this.getCertificateData(props.data.psCertificationId);
  //       });
  //       return eDiv;

  //     }
  //   },
  //   //{ headerName: 'PSID', field: 'powerSupplyId',minWidth: 70, width: 70 },
  //   { headerName: 'CertID', field: 'psCertificationId',minWidth: 70, width: 70 },
  //   { headerName: 'Certificate Date', field: 'certificationDate',minWidth: 140, width: 140 },
  //   { headerName: 'Technician Name', field: 'technicianName',minWidth: 140, width: 140  },
  //   { headerName: 'Mac Address', field: 'macAddress',minWidth: 100, width: 100 },
  //   { headerName: 'Type Of Visit', field: 'typeOfVisit',minWidth: 200, width: 200 },
  //   { headerName: 'Inspection Date', field: 'inspectionDate',minWidth: 130, width: 130  },
  //   { headerName: 'Last Updated By', field: 'logName',minWidth: 150, width: 150  },
  //   { headerName: 'Last Updated Date', field: 'logDate',minWidth: 150, width: 150 },

  // ];

  getCertificateData(psCertificationId){
    //this.gridApi.showLoadingOverlay();
    this.showLoading = true;
    if(psCertificationId != null){
      this.powerSupplyService.getPSCertifications(this.powerSupplyIdval,psCertificationId).subscribe(certData => {
        //this.certData = certData[0];
            this.sharedService.editpssetDatadetailview(certData);
           // this.gridApi.hideOverlay()
            this.sharedService.editpssetDatadetailviewtab('tabview')
            //this.gridApi.showNoRowsOverlay();
            this.ref.markForCheck();
            this.showLoading = false;
        });
    }
  }

  // onGridReady(params) {
  //   this.gridApi = params.api;
  //   this.gridColumnApi = params.columnApi;
  //   params.api.sizeColumnsToFit();
  //   params.api.sizeColumnsToFit();
  //   window.addEventListener("resize", function () {
    //   setTimeout(function () {
    //     params.api.sizeColumnsToFit();
    //   });
    // });
  // }

}
